import { Outlet } from "react-router-dom";
import { LayoutDashboard, Shield, Search, Share2, Activity, FileText, Briefcase, Bot, GitBranch, Eye } from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/cyber-monitor/dashboard", description: "KPI overview & AI insights" },
  { id: "entities", label: "Entities", icon: Search, path: "/cyber-monitor/entities", description: "Entity discovery & transforms" },
  { id: "graph", label: "Graph", icon: Share2, path: "/cyber-monitor/graph", description: "Relationship graph visualization" },
  { id: "monitors", label: "Monitors", icon: Activity, path: "/cyber-monitor/monitors", description: "Monitoring jobs & alerts" },
  { id: "cases", label: "Cases", icon: Briefcase, path: "/cyber-monitor/cases", description: "Investigation case management" },
  { id: "evidence", label: "Evidence", icon: FileText, path: "/cyber-monitor/evidence", description: "Digital evidence & chain of custody" },
  { id: "ai", label: "AI Assistant", icon: Bot, path: "/cyber-monitor/ai", description: "AI investigation copilot" },
];

export default function CyberMonitorLayout() {
  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="AllBaise Cyber Monitor"
        subtitle="Threat Intelligence Hub"
        icon={Shield}
        gradient="from-red-600 to-orange-600"
        activeBg="bg-red-500"
      />
      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
